import produce from 'immer';
import { create } from 'zustand';

const useNonProfitStore = create((set, get) => ({
  nonProfit: null,
  setNonProfit: (nonProfit) => {
    set(
      produce((draft) => {
        draft.nonProfit = nonProfit;
      }),
    );
  },
  init: (nonProfit) => {
    set(
      produce((draft) => {
        draft.nonProfit = nonProfit;
      }),
    );
  },
}));

export default useNonProfitStore;
